import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: false
})

export class AuthComponent {
    public isLoading: boolean = true;

    constructor(
        private router: Router
    ) {
    }

    //*************************************************************************
    //  Component Life-Cycle Methods
    //*************************************************************************
    public async ngOnInit() {
        let redirect = sessionStorage.getItem("_redirect");

        sessionStorage.removeItem("_redirect");

        if (redirect && redirect !== "") {
            this.router.navigateByUrl(redirect);
		} else {
            this.router.navigateByUrl("/");
        }

        this.isLoading = false;
    }
}
